<template>
  <section id="section__complete" class="view-container">
    <div class="width-100">
      <v-row no-gutters class="mt-10">
        <v-col cols="12">
          <p class="font--p-3">서비스 신청을 완료했어요!</p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <img src="@/assets/images/apply/clap.png" class="clap" />
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-5">
        <v-card class="card">
          <v-col cols="12">
            <v-card-text class="font--m-3">미리 준비하면 좋은 서류</v-card-text>
            <v-card-text class="font-size--18">
              신분증 <br />
              사업자등록증 <br />
              경남은행 통장 사본 <br />
              소득금액증명원 <br />
            </v-card-text>
          </v-col>
        </v-card>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <p class="font-size--18 color--nice">
            전담 상담원이 유선으로 <br />
            상세하게 안내를 해드릴게요
          </p>
        </v-col>
      </v-row>

      <BasicButton @click="next">신청 확인</BasicButton>
    </div>
  </section>
</template>
<script>
import { closeBrowser } from '@/util'
export default {
  methods: {
    next() {
      closeBrowser()
    },
  },
}
</script>
<style lang="scss" scoped>
#section__complete {
  text-align: center;

  .clap {
    width: 100%;
    height: 210px;
    object-fit: contain;
  }

  .card {
    width: 100%;
    background-color: #e5f6ff;
  }
}
</style>
